import { useState, useMemo } from 'react';
import { usePosts } from '../../contexts/PostContext';
import { TAGS } from '../../assets/mockData';
import PostCard from './PostCard';
import PostCreate from './PostCreate';

export default function PostFeed() {
  const { posts } = usePosts();
  const [selectedTags, setSelectedTags] = useState([]);
  const [showCreate, setShowCreate] = useState(false);

  const toggleTag = (tag) => {
    setSelectedTags((prev) =>
      prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
    );
  };

  const filtered = useMemo(() => {
    if (!selectedTags.length) return posts;
    return posts.filter((p) => p.tags?.some((t) => selectedTags.includes(t)));
  }, [posts, selectedTags]);

  return (
    <div className="feed-container">
      <div className="feed-sidebar">
        <div className="tag-filter">
          <h3 className="sidebar-title">兴趣标签</h3>
          <div className="tag-list">
            {TAGS.map((tag) => (
              <button
                key={tag}
                className={`tag-chip ${selectedTags.includes(tag) ? 'active' : ''}`}
                onClick={() => toggleTag(tag)}
              >
                #{tag}
              </button>
            ))}
          </div>
          {selectedTags.length > 0 && (
            <button className="tag-clear" onClick={() => setSelectedTags([])}>
              清除筛选
            </button>
          )}
        </div>
      </div>

      <div className="feed-main">
        <button className="fab-create" onClick={() => setShowCreate(true)}>
          <svg viewBox="0 0 24 24" width="24" height="24">
            <line x1="12" y1="5" x2="12" y2="19" stroke="white" strokeWidth="2" strokeLinecap="round" />
            <line x1="5" y1="12" x2="19" y2="12" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        {filtered.length === 0 ? (
          <div className="feed-empty">
            <div className="feed-empty-icon">📭</div>
            <p>没有找到相关动态</p>
            {selectedTags.length > 0 && <p>试试其他标签吧</p>}
          </div>
        ) : (
          <div className="post-list">
            {filtered.map((post) => (
              <PostCard key={post.id} post={post} />
            ))}
          </div>
        )}
      </div>

      <PostCreate open={showCreate} onClose={() => setShowCreate(false)} />
    </div>
  );
}
